/**
 * TeamAutocompleteField Component (issue #649)
 *
 * Filterable/typeahead team selector. Thin, Team-flavored wrapper around the
 * generic `EntityAutocompleteField` (extracted in issue #769) — sets the
 * Team-specific default placeholder/empty-message copy and preserves this
 * component's original wrapper class name (`.team-autocomplete-field-wrapper`)
 * for CSS/test-selector backward compatibility.
 */

import {
  EntityAutocompleteField,
  type EntityAutocompleteFieldProps,
  type EntityAutocompleteOption,
} from './EntityAutocompleteField';
import './TeamAutocompleteField.css';

export type TeamAutocompleteOption = EntityAutocompleteOption;

export type TeamAutocompleteFieldProps = Omit<EntityAutocompleteFieldProps, 'wrapperClassName'>;

/**
 * @example
 * ```tsx
 * <TeamAutocompleteField
 *   label="Team"
 *   options={teams.map((t) => ({ value: t.entityId, label: t.name }))}
 *   value={values.teamId}
 *   onChange={(teamId) => setValue('teamId', teamId, { shouldValidate: true })}
 *   error={errors.teamId}
 * />
 * ```
 */
export function TeamAutocompleteField({
  placeholder = 'Search teams…',
  emptyMessage = 'No accessible teams match your search',
  ...rest
}: TeamAutocompleteFieldProps): JSX.Element {
  return (
    <EntityAutocompleteField
      {...rest}
      placeholder={placeholder}
      emptyMessage={emptyMessage}
      wrapperClassName="team-autocomplete-field-wrapper"
    />
  );
}
